const formatTimeToRead = (timeToRead, lang) => {
  if (lang === "vi") {
    return `${timeToRead} phút đọc`;
  }
  return `${timeToRead} ${timeToRead > 1 ? "mins" : "min"} read`;
};

export default formatTimeToRead;
